import { LocalStorageService } from "src/app/_services/localStorage.service";
import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/_services/app.service";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-withdraw-modal",
  templateUrl: "./withdraw-modal.component.html",
  styleUrls: ["./withdraw-modal.component.scss"],
  standalone: false,
})
export class WithdrawModalComponent implements OnInit {
  tarif: string = "";
  constructor(
    private appService: AppService,
    private localStorageService: LocalStorageService,
    private modalController: ModalController
  ) {
    this.getTarif();
  }
  getTarif() {
    this.tarif = this.localStorageService.getTarif();
  }
  ngOnInit() {}
  closeModal() {
    this.modalController.dismiss();

    this.appService.dispatchModal("WITHDRAW_MODAL", false);
  }
}
